<template>
  <div class="section-wrapper">
    <template v-if="!sliderReady">
      <div class="alert alert-warning">
        <span>
          {{ $t("slider.labels.loading") }}
        </span>
      </div>
    </template>
    <template v-else>
      <h5>Slider</h5>
      <custom-add-insert-buttons
        :template="template"
        :list="sliderLocal"
        class="mb-4"
      />
      <div
        v-for="(slide, indx) in addKeysToList(sliderLocal)"
        :key="`slide_${slide.listKey}`"
        class="row pb-4 pt-4"
        :class="getAltClass(indx)"
      >
        <volcan-input-textarea
          v-if="showText"
          v-model="getSlideRes(slide).name"
          text="Texte"
          :class="getClassText"
          :rows="10"
        />
        <volcan-dropzone
          v-if="showPortraitImage"
          :hasDualUpload="false"
          :hasInfos="false"
          v-model="slide.portraitImage"
          :moduleName="moduleName"
          :options="{
            maxFiles: 1,
            thumbnailHeight: getThumbSize,
            thumbnailWidth: getThumbSize,
            dictDefaultMessage: $t('slider.labels.thumbs.dropFile'),
            acceptedFiles: 'image/*'
          }"
          :text="
            `${$t('slider.labels.thumbs.portraitImage')} ${portraitImageSize}`
          "
          :class="getClassImg"
          :key="`slide_portraitImage_${slide.listKey}`"
        />
        <volcan-dropzone
          v-if="showLandscapeImage"
          :hasDualUpload="false"
          :hasInfos="false"
          v-model="slide.landscapeImage"
          :moduleName="moduleName"
          :options="{
            maxFiles: 1,
            thumbnailHeight: getThumbSize,
            thumbnailWidth: getThumbSize,
            dictDefaultMessage: $t('slider.labels.thumbs.dropFile'),
            acceptedFiles: 'image/*'
          }"
          :text="
            `${$t('slider.labels.thumbs.landscapeImage')} ${landscapeImageSize}`
          "
          :class="getClassImg"
          :key="`slide_landscapeImage_${slide.listKey}`"
        />
        <volcan-dropzone
          v-if="showSideImage"
          :hasDualUpload="false"
          :hasInfos="false"
          v-model="slide.sideImage"
          :moduleName="moduleName"
          :options="{
            maxFiles: 1,
            thumbnailHeight: getThumbSize,
            thumbnailWidth: getThumbSize,
            dictDefaultMessage: $t('building.labels.thumbs.dropFile'),
            acceptedFiles: 'image/*'
          }"
          :text="$t('building.labels.thumbs.sideImage')"
          :class="getClassImg"
          :key="`slide_sideImage_${slide.listKey}`"
        />
        <volcan-cta
          v-if="showCta"
          v-model="slide.cta"
          :languageIdActive="languageIdActive"
          :key="`slide_cta_${slide.listKey}`"
          :class="getClassCta"
        />
        <div class="row col-12 justify-content-center">
          <span
            class="btn btn-secondary col-6 col-lg-4 btn-del-subitem"
            @click="removeItemAtIndex(sliderLocal, indx)"
            >Supprimer l'item</span
          >
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import en from "./admin-en.json";
import fr from "./admin-fr.json";
import helpers from "@mixins/helpers.js";
export default {
  name: "volcan-slider",
  mixins: [helpers],
  beforeMount() {
    this.$i18n.add("fr", fr);
    this.$i18n.add("en", en);
  },
  data: function() {
    return {
      // tabs: {
      //   languageIdActive: 0
      // }
    };
  },
  props: {
    slider: { type: Array },
    template: { type: Object },
    languageIdActive: { type: Number, default: 1 },
    moduleName: { type: String },
    landscapeImageSize: { type: String, default: "" },
    showLandscapeImage: { type: Boolean, default: true },
    portraitImageSize: { type: String, default: "" },
    showPortraitImage: { type: Boolean, default: true },
    showSideImage: { type: Boolean, default: true },
    showText: { type: Boolean, default: true },
    showCta: { type: Boolean, default: true }
  },
  model: {
    prop: "slider",
    event: "slider:change"
  },
  computed: {
    sliderLocal: {
      get: function() {
        return this.slider;
      },
      set: function(value) {
        this.$emit("slider:change", value);
      }
    },
    sliderReady() {
      return (this.sliderLocal || this.template) && this.languageIdActive !== 0; //&& this.getRes(this.sliderLocal);
    },
    currentRes() {
      return this.getResWithLangId(this.sliderLocal, this.languageIdActive);
    },
    imgCount() {
      return (
        this.getInt(this.showLandscapeImage) +
        this.getInt(this.showPortraitImage) +
        this.getInt(this.showSideImage)
      );
    },
    propShowCount() {
      return (
        this.getInt(this.showLandscapeImage) +
        this.getInt(this.showPortraitImage) +
        this.getInt(this.showSideImage) +
        this.getInt(this.showText) +
        this.getInt(this.showCta)
      );
    },
    getThumbSize() {
      let c = this.imgCount;
      return c === 3 ? 100 : 150;
    },
    getClassImg() {
      let c = this.imgCount;
      var sm =
        c === 1 && this.showCta ? "6" : c === 1 ? "12" : c === 2 ? "6" : "4";
      var xl =
        c === 1 && this.showCta ? "6" : c === 1 ? "12" : c === 2 ? "6" : "4";
      return `col-12 col-sm-${sm} col-xl-${xl}`;
    },
    getClassCta() {
      // if(this.propShowCount % 2 === 0){
      // return `col-6 col-xl-6`;
      // }
      let c = this.imgCount;
      var sm = c === 1 ? "6" : c === 2 ? "12" : "12";
      var xl = c === 1 ? "6" : c === 2 ? "12" : "12";
      var mt = c === 1 ? "mt-3" : "";
      return `col-12 col-sm-${sm} col-xl-${xl} ${mt}`;
    },
    getClassText() {
      return `col-12`;
      // // if(this.propShowCount % 2 === 0){
      // // return `col-6 col-xl-6`;
      // // }

      // let c = this.imgCount;
      // var sm = c === 1 ? "6" : c === 2 ? "12" : "12";
      // var xl = c === 1 ? "6" : c === 2 ? "12" : "12";
      // var mt = c === 1 ? "mt-3" : "";
      // return `col-6 col-sm-${sm} col-xl-${xl} ${mt}`;
    }
  },
  methods: {
    getSlideRes(it) {
      return this.getResWithLangId(it, this.languageIdActive);
    },
    getInt(val) {
      return val ? 1 : 0;
    },
    getAltClass(indx) {
      let even = indx % 2 === 0 ? true : false;
      return even ? "even" : "odd";
    }
  }
};
</script>
<style scoped>
/* .even {
  background: #f3eded;
} */
.odd {
  background: #f3eded;
}
</style>



// WEBPACK FOOTER //
// components/Custom/Slider/slider.vue